import React from "react";
import Reveal from "./Reveal";

const rows = [
  { platform: "Reads your prompts", fabstir: "Sealed end to end; no one in the middle" },
  { platform: "“Trust us”", fabstir: "A tamper-proof receipt for every job" },
  { platform: "Prices set to maximise margin", fabstir: "Prices set by open competition" },
  { platform: "Vendor lock-in", fabstir: "Switch by changing one setting" },
];

// The montage's red/green comparison slide, rebuilt as real (animated) HTML.
export default function ComparisonSection() {
  return (
    <div className="mx-auto mt-24 max-w-5xl px-6 sm:mt-44 lg:px-8">
      <Reveal>
        <div className="grid grid-cols-2 gap-x-6 text-center sm:gap-x-12">
          <h3 className="text-sm font-semibold uppercase tracking-[0.2em] text-red-400 sm:text-base">
            AI platforms
          </h3>
          <h3 className="text-sm font-semibold uppercase tracking-[0.2em] text-emerald-400 sm:text-base">
            Fabstir AI
          </h3>
        </div>
      </Reveal>
      <div className="mt-8 space-y-4">
        {rows.map((row, i) => (
          <Reveal key={row.platform} delay={i * 120}>
            <div className="grid grid-cols-2 gap-x-6 rounded-xl bg-white/5 px-4 py-5 ring-1 ring-white/10 sm:gap-x-12 sm:px-8">
              <p className="text-center text-sm font-medium text-red-300/90 sm:text-lg">
                {row.platform}
              </p>
              <p className="text-center text-sm font-medium text-emerald-300 sm:text-lg">
                {row.fabstir}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
